/*
 *  I01EVAECSQUALICalcul.js
 *
 *  Created by Sébastien Hecart on 2017-12-09 23:13:24 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
import { fetchLogementCompositionECS, fetchQualitelWithDTU } from '@batical/data/src'
import i18n from '@batical/i18n'
import { I01EVAECSQUALI_State } from '@batical/types/src'

function I01EVAECSQUALI_docalcul(state: I01EVAECSQUALI_State) {
  state.res_totalLogementStandard = 0
  state.res_totalLogementStandard += state.in_t1_Ddo * fetchLogementCompositionECS('1').coeffQualitel
  state.res_totalLogementStandard += state.in_t1_ba * fetchLogementCompositionECS('2').coeffQualitel
  state.res_totalLogementStandard += state.in_t2_do * fetchLogementCompositionECS('3').coeffQualitel
  state.res_totalLogementStandard += state.in_t2_ba * fetchLogementCompositionECS('4').coeffQualitel
  state.res_totalLogementStandard += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').coeffQualitel
  state.res_totalLogementStandard += state.in_t3_ba_do * fetchLogementCompositionECS('6').coeffQualitel
  state.res_totalLogementStandard += state.in_t4_ba * fetchLogementCompositionECS('7').coeffQualitel
  state.res_totalLogementStandard += state.in_t4_ba_do * fetchLogementCompositionECS('8').coeffQualitel
  state.res_totalLogementStandard += state.in_t56_ba * fetchLogementCompositionECS('9').coeffQualitel
  state.res_totalLogementStandard += state.in_t56_ba_do * fetchLogementCompositionECS('10').coeffQualitel
  state.res_totalLogementStandard += state.in_T56_2ba * fetchLogementCompositionECS('11').coeffQualitel

  const squali = fetchQualitelWithDTU(state.res_totalLogementStandard)
  if (squali != null) {
    state.res_s1 = squali.s1
    state.res_s2 = squali.s2
    state.res_s3 = squali.s3
  } else {
    state.res_s1 = 0
    state.res_s2 = 0
    state.res_s3 = 0
  }
  if (state.in_typeCalcul === 1) {
    //evier
    var tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_evier
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_evier
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_evier
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_evier
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_evier
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_evier
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_evier
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_evier
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_evier
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_evier
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_evier
    var debitBrut = tempCalc
    var debitTotal = tempCalc * 0.133
    //vasque
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_vasque
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_vasque
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_vasque
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_vasque
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_vasque
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_vasque
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_vasque
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_vasque
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_vasque
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_vasque
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_vasque
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.133
    //douche
    tempCalc = 0
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_douche
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_douche
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_douche
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_douche
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_douche
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_douche
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_douche
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_douche
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_douche
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_douche
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_douche
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.133
    //baignoe
    tempCalc = 0
    tempCalc = state.in_t1_Ddo * fetchLogementCompositionECS('1').nb_baignoire
    tempCalc += state.in_t1_ba * fetchLogementCompositionECS('2').nb_baignoire
    tempCalc += state.in_t2_do * fetchLogementCompositionECS('3').nb_baignoire
    tempCalc += state.in_t2_ba * fetchLogementCompositionECS('4').nb_baignoire
    tempCalc += state.in_t3_ev_lav_ba * fetchLogementCompositionECS('5').nb_baignoire
    tempCalc += state.in_t3_ba_do * fetchLogementCompositionECS('6').nb_baignoire
    tempCalc += state.in_t4_ba * fetchLogementCompositionECS('7').nb_baignoire
    tempCalc += state.in_t4_ba_do * fetchLogementCompositionECS('8').nb_baignoire
    tempCalc += state.in_t56_ba * fetchLogementCompositionECS('9').nb_baignoire
    tempCalc += state.in_t56_ba_do * fetchLogementCompositionECS('10').nb_baignoire
    tempCalc += state.in_T56_2ba * fetchLogementCompositionECS('11').nb_baignoire
    debitBrut += tempCalc
    debitTotal += tempCalc * 0.33
    state.res_simuDTU = 0.8 / Math.sqrt(debitBrut - 1)
    state.res_effEchangeur = (state.in_tempBouclage - state.in_tempFroide) / (state.in_tempStackage - state.in_tempRetour)
    state.res_debitDTU = debitTotal * state.res_simuDTU * 60
    state.res_puissMiniQualitel = state.res_totalLogementStandard * state.res_s1 * 21
  } else {
    state.res_simuDTU = 0.0
    state.res_effEchangeur = 0.0
    state.res_debitDTU = 0.0
    state.res_puissMiniQualitel = 0.0
  }
  //   I01EVAECSQUALI_p_inst: 'Puissance Instantanée',
  //   I01EVAECSQUALI_couple_semi: 'Couple Semi-instantané',
  //   I01EVAECSQUALI_couple_semiacc: 'Couple Semi-accumulé',
  //   I01EVAECSQUALI_couple_acc: 'Couple à Accumulation',
  //   I01EVAECSQUALI_couple_acc_prim: 'Couple à accumulation primaire',
  //   I01EVAECSQUALI_couple_semi_prim: 'Couple semi-instantané primaire',
  //   I01EVAECSQUALI_couple_semiacc_prim: 'Couple semi-accumulé primaire',
  let limiteSemi = 20 * state.res_totalLogementStandard
  let limiteSemiAcc = 150 * state.res_s3 * state.res_totalLogementStandard
  if (state.in_typeCalcul === 1) {
    limiteSemi = limiteSemi * state.res_effEchangeur
    limiteSemiAcc = limiteSemiAcc * state.res_effEchangeur
  }
  if (state.in_typeCalcul === 0 && state.in_volume === 0) {
    state.res_modePuissance = i18n.t('I01EVAECSQUALI_p_inst')
    state.res_puissance = state.res_puissance = state.res_totalLogementStandard * state.res_s1 * 21
  } else if (state.in_volume < limiteSemi) {
    state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_semi')
    //=calcul!D14*(0,25*calcul!C19-1,05*calcul!B19)*C30/calcul!D14+21*calcul!B19*calcul!D14
    state.res_puissance =
      (state.res_totalLogementStandard * (0.25 * state.res_s2 - 1.05 * state.res_s1) * state.in_volume) / state.res_totalLogementStandard +
      21 * state.res_totalLogementStandard * state.res_s1
    if (state.in_typeCalcul === 1) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_semi_prim')
      // state.res_puissance = state.res_puissance * state.res_effEchangeur;
      state.res_puissance = Math.min(state.res_puissance * state.res_effEchangeur, state.res_puissMiniQualitel)
    }
    //=calcul!D14*(0,25*calcul!C19-1,05*calcul!B19)*C30/calcul!D14+21*calcul!B19*calcul!D14
  } else if (state.in_volume < limiteSemiAcc) {
    //=(((0,535*calcul!B19+0,214-2,5*calcul!C19)*(C34/calcul!D14-20)/(75*calcul!D19-10))+5*calcul!C19)*calcul!D14
    state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_semiacc')
    state.res_puissance =
      (((0.535 * state.res_s1 + 0.214 - 2.5 * state.res_s2) * (state.in_volume / state.res_totalLogementStandard - 20)) /
        (75 * state.res_s3 - 10) +
        5 * state.res_s2) *
      state.res_totalLogementStandard
    if (state.in_typeCalcul === 1) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_semiacc_prim')
      state.res_puissance = state.res_puissance * state.res_effEchangeur
    }
  } else {
    //=calcul!D14*(7,14*C38/calcul!D14+428)/1000
    state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_acc')
    state.res_puissance = (state.res_totalLogementStandard * ((7.14 * state.in_volume) / state.res_totalLogementStandard + 428)) / 1000
    if (state.in_typeCalcul === 1) {
      state.res_modePuissance = i18n.t('I01EVAECSQUALI_couple_acc_prim')
      state.res_puissance = state.res_puissance * state.res_effEchangeur
    }
  }
  state.invalidated = false
  return state
}

export default I01EVAECSQUALI_docalcul
